module.exports = __webpack_public_path__ + "static/media/step6.c48bb775.png";